module.exports = " <div class=vc-snack-bar transition=vc-snack> <div class=vc-snack-message> {{message}} </div> <vc-button v-if=action :text=action @click=actionClick :color=actionColor></vc-button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/bars/snackBar.vue
 ** module id = 417
 ** module chunks = 1
 **/